import React, { useState, useEffect } from "react"
import { IBaseFieldProperties, RadioBooleanValueLabel } from "./interfaces"

export interface RadioBooleanBtnsFieldProperties extends IBaseFieldProperties {
  value?: boolean
  options: RadioBooleanValueLabel[]
}

export const RadioBooleanBtnsField = (
  props: RadioBooleanBtnsFieldProperties
) => {
  const [value, setValue] = useState(props.value)

  useEffect(() => {
    setValue(props.value)
  }, [props.value])

  const handleOnValueChange = (val: boolean) => {
    setValue(val)

    if (typeof props.onChange === "function") {
      props.onChange(props.name, val)
    }
  }

  const btns = props.options.map((opt, idx) => (
    <div
      key={idx}
      className={
        "radio-field ocs-radio-btn" +
        (opt.label === "Local" ? " ocs-radio-btn-local" : "") +
        (opt.value === value ? " ocs-radio-btn-checked" : "")
      }
      onClick={() => handleOnValueChange(opt.value)}
    >
      <label className="ocs-radio-container d-flex align-items-center">
        <input
          type="radio"
          style={{ cursor: "pointer" }}
          checked={opt.value === value}
          onChange={() => {}}
        />
        <span className="ocs-radio-check" />
        {opt.label}
      </label>
    </div>
  ))
  const chosenOpt = props.options.find((o) => o.value === value)

  return (
    <div
      className={
        "ocs-field-container" +
        (!props.caption ? " h-100 d-flex align-items-end" : "")
      }
    >
      {props.caption && <label htmlFor="">{props.caption}</label>}
      {props.readonly ? (
        <p className="ocs-field-readonly">
          {chosenOpt ? chosenOpt.label : null}
        </p>
      ) : (
        <div className="d-flex mq-flex-direction-row">{btns}</div>
      )}
    </div>
  )
}
export default RadioBooleanBtnsField
